import { useState, useEffect } from "react";
import { siteConfig } from "@/config/siteConfig";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export function FloatingWhatsAppIcon() {
  // Don't render if disabled
  if (!siteConfig.whatsappChatbot.enabled || !siteConfig.whatsappChatbot.whatsappUrl) {
    return null;
  }

  const [isVisible, setIsVisible] = useState(false);

  // Show the icon after a short delay for better UX
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleWhatsAppClick = () => {
    window.open(siteConfig.whatsappChatbot.whatsappUrl, '_blank');
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
        {siteConfig.whatsappChatbot.floatingIconText}
        <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900" />
      </div>

      {/* Main button */}
      <button
        onClick={handleWhatsAppClick}
        className="group relative w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center animate-bounce hover:animate-none hover:scale-110 focus:outline-none focus:ring-4 focus:ring-green-300/50"
        aria-label={siteConfig.whatsappChatbot.floatingIconText}
        title={siteConfig.whatsappChatbot.floatingIconText}
      >
        {/* Pulse animation - positioned outside button to not interfere with clicks */}
        <div className="absolute -inset-1 rounded-full bg-green-400 animate-ping opacity-20 pointer-events-none" />
        
        {/* WhatsApp Icon - positioned with proper z-index */}
        <WhatsAppIcon size={28} variant="white" className="relative z-10" />
        
        {/* Notification dot - positioned to not interfere with main clickable area */}
        <div className="absolute -top-0.5 -right-0.5 w-3 h-3 bg-red-500 rounded-full flex items-center justify-center border border-white">
          <div className="w-1.5 h-1.5 bg-white rounded-full animate-pulse" />
        </div>
      </button>
    </div>
  );
}
